import React, { Fragment } from 'react'
import { PagerButton, Voiceover, Intro } from 'cvs-core'
import img1 from '../../assets/images/U2-T1-1-5a.svg'
import img2 from '../../assets/images/U2-T1-1-5b.svg'
import img3 from '../../assets/images/U2-T1-1-5c.svg'
import img4 from '../../assets/images/U2-T1-1-5d.svg'
import img5 from '../../assets/images/U2-T1-1-5e.svg'
import voAudio from '../../assets/vo/CVS-HS-SPM-Learn-01.mp3'

const vo = {
  sources: [
    {
      src: voAudio,
    },
  ],
  transcript:
    'Let’s review what you already know about the dangers of vaping. Vaping affects the brain and body. E-cigarettes can be highly addictive and teen brains are especially susceptible. Vaping doesn’t actually have anything to do with water vapor. It produces an aerosol that contains toxic chemicals. There are also social consequences to vaping, like losing friends, adult distrust, and those that come with breaking the rules. There are positive ways to respond to the negative pressure to vape.',
}

export default {
  title: 'Let’s Review!',
  path: '/prepare/let’s-review!',
  content: (
    <Fragment>
      <Voiceover {...vo} />
      <Intro title="Let’s Review!" />
      <article>
        <img
          src={img1}
          alt=""
          className="img-center"
          height="235"
          width="568"
        />
        <h2>Negative Effects</h2>
        <p style={{ marginBottom: '50px' }}>
          Vaping can have harmful effects on both your brain and your body.
          Because teens’ brains and bodies are still developing, vaping can be
          even more dangerous for you.
        </p>

        <img
          src={img2}
          alt=""
          className="img-center"
          height="235"
          width="568"
        />
        <h2>Vaping and the Brain</h2>
        <p style={{ marginBottom: '50px' }}>
          E-cigarettes contain highly addictive nicotine, and it can be hard to
          quit once you start. Addiction is a brain disease that changes your
          brain, often in a permanent way. Because teen brains are still
          developing, especially the decision-making prefrontal cortex, they are
          especially vulnerable. This can cause trouble with memory,
          concentration, and decision making. It can also cause emotional and
          mental health challenges.
        </p>

        <img
          src={img3}
          alt=""
          className="img-center"
          height="235"
          width="568"
        />
        <h2>Vaping and the Body</h2>
        <p style={{ marginBottom: '50px' }}>
          E-cigarettes deliver many toxins to the body. While the term “vaping”
          might make you think of water vapor, the aerosol you inhale when
          vaping is actually full of chemicals, many of them toxic. These
          chemicals can cause damage to your mouth, throat, and lungs. Finally,
          the liquid used to vape is harmful and can be fatal if swallowed.
        </p>

        <img
          src={img4}
          alt=""
          className="img-center"
          height="235"
          width="568"
        />
        <h2>Social Consequences of Vaping</h2>
        <p style={{ marginBottom: '50px' }}>
          If you use e-cigarettes, others might decide to not hang out with you
          anymore. Your reputation could be affected, and you could be seen as a
          negative influence. Additionally, the adults in your life might lose
          trust in you. You could face consequences at home like being grounded
          or getting your phone taken away. Furthermore, you can face school
          consequences, like detention or suspension if you’re caught vaping.
          You could also get kicked off a team or out of a club. Finally,
          purchasing e-cigarettes is against the law for anyone under 21.
        </p>

        <img
          src={img5}
          alt=""
          className="img-center"
          height="235"
          width="568"
        />
        <h2>Responding to Pressure to Vape</h2>
        <p style={{ marginBottom: '50px' }}>
          There are positive ways to respond to the negative pressure to vape.
          You could respond with a direct refusal and simply say no. It’s also
          smart to have a plan to remove yourself from situations where vaping
          might occur; this is called an exit strategy. Sharing information that
          you learn about vaping with your friends is a good way to keep you and
          them safe. And you can always rely on human resources, like trusted
          adults, parents, teachers, and coaches
        </p>
      </article>

      <PagerButton />
    </Fragment>
  ),
}



// WEBPACK FOOTER //
// ./src/data/Learn/LetsReview.js